function setupStickies() {
  const stickies = document.querySelectorAll('.hide-until-scroll');
  const windowHeight = window.outerHeight;
  const footerHeight = document.querySelector('footer').offsetHeight;
  const stopHeight = document.body.offsetHeight - windowHeight - footerHeight;

  stickies.forEach( block => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > stopHeight){
        block.classList.remove('show');
      } else if (window.scrollY > 500) {
        block.classList.add('show');
      } else{
        block.classList.remove('show');
      }
    });
  });
}

export default setupStickies;